<div *ngIf="!request.reply.replyItems[Index].isDone && request.reply.replyItems[Index].solutionStep.actionEmail?.requiredConfirm">
  <div class="row">
    <div class="col-md-8">
      <div class="mb-2"><strong>{{'admin.emails.manage.body_information'|translate}} </strong></div>
      <nav ngbNav #nav="ngbNav" class="nav nav-tabs">
        <div ngbNavItem *ngFor="let tab of tabs;let i=index">
          <a ngbNavLink class="nav-link">{{tab.title}}</a>
          <ng-template ngbNavContent>
            <div [@fadeInOutTranslate] class="m-t-15">
              <quill-editor [modules]="modules" [readOnly]="!isActive"  (onContentChanged)="updateEmailBody()" [name]="Index+'email'+i" [(ngModel)]="request.reply.replyItems[this.Index].replyEmail[tab.mapping]" (ngModelChange)="updateServiceRequest()" ></quill-editor>
            </div>
          </ng-template>
        </div>
      </nav>
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
      <div class="row token-header mx-0 ms-0">
        <div class="col-md-6">{{'admin.general_items.name' | translate}}</div>
        <div class="col-md-6">{{'global.token' | translate}}</div>
      </div>
      <div *ngFor="let token of tokens; let i = index" class="row mx-0 ms-0">
        <div class="col-md-6">{{token.description}}</div>
        <div class="col-md-6 cursor-pointer" [copy-clipboard]="token.name" (copied)="clipboardUpdated()"
            ngbTooltip="{{'admin.emails.manage.click_to_copy' | translate}}" placement="left">{{token.name}}
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="offset-md-2"></div>
    <div class="col-md-8" style="padding-right:0">
      <div class="mt-4">
        <div class="box box-default min-margin">
          <div class="box-body">
            <div class="form-group">
              <div class="manage-title">
                <ng-container *ngIf="!iframeUrl">{{'admin.emails.manage.email_preview_loading'|translate}}
                </ng-container>
                <iframe *ngIf="iframeUrl" [src]="iframeUrl" width="100%" height='450px'
                        class="email-preview" style="border:1px solid lightgray; padding: 0 10px"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="offset-md-2"></div>
  </div>
</div>
<button *ngIf="!request.reply.replyItems[Index].isDone  && request.reply.replyItems[Index].solutionStep.actionEmail?.requiredConfirm"
 [disabled]="!isActive || request.isArchived" class="btn btn-primary ripple light pull-right my-3" (click)="confirmStep()" type="button">{{'global.send'|translate}}</button>

<div *ngIf="request.reply.replyItems[Index].isDone && request.reply.replyItems[Index].solutionStep.actionEmail?.requiredConfirm === false && !isActive">
  <p>{{'doctrine.solution.action_email.email_will_sent' | translate}}</p>
</div>
<div *ngIf="request.reply.replyItems[Index].isDone">
  <p>{{'doctrine.solution.action_email.email_sent' | translate}}</p>
</div>

<button *ngIf="request.reply.replyItems[Index].isDone"
 [disabled]="!isActive" class="btn btn-primary ripple light pull-right my-3" (click)="showPreview()" type="button">{{'global.preview'|translate}}</button>


 <app-modal-basic *ngIf="request.reply.replyItems[Index].isDone" #previewModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">&nbsp;</h4>
    <button type="button" class="close basic-close" (click)="previewModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body p-0">
    <iframe [frameBorder]="0" [src]="iframeUrl" height='450px' width="100%"></iframe>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"   (click)="previewModal.hide()">{{'global.close'|translate}}</button>
  </div>
</app-modal-basic>
